import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "environments/environment";
import * as _ from "lodash";
import * as moment from "moment";
import { BARRACKS, Constants, PUBLIC_POST_GROUP } from "./Constants";
import { UserDataService } from "./user-data.service";

@Injectable({
  providedIn: "root",
})
export class HelperService {
  map: any = {};
  constructor(private activatedRoute: ActivatedRoute) {
    this.map = {
      party_post_id: "_p",
      barrack_id: "_b",
      barrack_index: "_b_i",
      country_id: "_c",
      country_name: "_c_n",
      party_post_group_id: "_p_g",
      party_post_subgroup_id: "_p_s_g",
      lp: "_l",
    };
  }

  getMangledName(str: string) {
    return str;
    // if (isDevMode()) {
    //   return str;
    // }

    // var encodedStr = str;
    // for (var i = 0; i < 4; i++) {
    //   encodedStr = btoa(encodedStr.split("=").join("_"));
    // }
    // return encodedStr.split("=").join("_").split("").reverse().join("");
  }

  getAPIUrl() {
    return environment.API_URL;
  }
  getAPIUrl1() {
    // return environment.API_CONTRIBUTION_POST; commented by siva
    return environment.API_CONTRIBUTION_UPDATE;
  }
  getAPIUrl2() {
    return environment.API_CONTRIBUTION_RECEIPT;
  }
  getAPIUrl3() {
    return environment.API_EVENT_TYPES;
  }
  getAPIUrl4() {
    return environment.API_EVENT;
  }

  accessPermissible(
    rights: any,
    parameters: any,
    party_post_group_id: number,
    barrack_id: number,
    control_id: number,
    access_code: number
  ) {
    if (!rights || !parameters.hasOwnProperty("party_post_subgroup_id")) {
      return false;
    }
    var barrack_index = BARRACKS[barrack_id];
    var placeId = -1;
    var skipPlaceId = false;

    if (parameters.lp == 42) {
      placeId = parameters.loksabha_cons_id;
    } else if (parameters.lp == 58) {
      if ([6, 12].includes(parameters.party_post_group_id)) {
        //ஒன்றியம்
        placeId = parameters.cons_circle_id;
      } else if ([11, 19].includes(parameters.party_post_group_id)) {
        placeId = parameters.section_id;
      } else placeId = parameters.const_id;
    } else if (parameters.lp == 44 || parameters.lp == 64) {
      placeId = parameters.country_id;
    } else if (parameters.lp == 35) {
      placeId = parameters.zone_id;
    } else if (parameters.lp == 72) {
      placeId = parameters.district_id;
    }

    if (
      parameters.party_post_subgroup_id >= 80 &&
      parameters.party_post_subgroup_id < 90
    ) {
      skipPlaceId = true;
    } else if (parameters.party_post_subgroup_id == 90) {
      return true;
    }

    for (var index = 0; index < rights.length; index++) {
      var right = rights[index];
      if (Constants.VIEW_ACCESS == access_code) {
        if (
          right.controldId == control_id &&
          right.viewAccessBarracks & barrack_index &&
          (right.placeId == placeId || skipPlaceId) &&
          right.accessView == 1
        ) {
          if (right.restrictions & Constants.PARTY_POST_ENABLE_VIEW_ACCESS) {
            return true;
          }
        }
      } else if (Constants.EDIT_ACCESS == access_code) {
        if (
          right.controldId == control_id &&
          right.editAccessBarracks & barrack_index &&
          (right.placeId == placeId || skipPlaceId) &&
          right.accessEdit == 1
        ) {
          if (right.restrictions & Constants.PARTY_POST_ENABLE_EDIT_ACCESS) {
            return true;
          }
        }
      }
    }
    return false;
  }

  editAccessAvailable(rights: any, parameters: any, control_id: number) {
    return true;
    //  this.accessPermissible(
    //   rights,
    //   parameters,
    //   1,                                     Todo commented by Siva
    //   parameters.barrack_id,
    //   control_id,
    //   Constants.EDIT_ACCESS
    // );
  }

  viewAccessAvailable(rights: any, parameters: any, control_id: number) {
    return true;
    // if (!parameters.hasOwnProperty("barrack_id")) {
    //   return false;
    // }

    // return this.accessPermissible(                   Todo commented by Siva
    //   rights,
    //   parameters,
    //   1,
    //   parameters.barrack_id,
    //   control_id,
    //   Constants.VIEW_ACCESS
    // );
  }

  viewAccess(
    rights: any,
    parameters: any,
    party_post_group_id: number,
    barrack_id: number,
    control_id: number
  ) {
    return true;
    // return this.accessPermissible(
    //   rights,
    //   parameters,
    //   party_post_group_id,                        Todo commented by Siva
    //   barrack_id,
    //   control_id,
    //   Constants.VIEW_ACCESS
    // );
  }

  editAccess(
    rights: any,
    parameters: any,
    party_post_group_id: number,
    barrack_id: number,
    control_id: number
  ) {
    return true;
    // return this.accessPermissible(
    //   rights,
    //   parameters,
    //   party_post_group_id,                   Todo commented by Siva
    //   barrack_id,
    //   control_id,
    //   Constants.EDIT_ACCESS
    // );
  }

  getRandomColor(index): string {
    return Constants.colorArray[index % Constants.colorArray.length];
  }

  getUniqueString(): string {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  }

  storePageData(params: any, key = this.getUniqueString()): string {
    localStorage.setItem(key, JSON.stringify(params));
    return key;
  }

  getParameters(arg0: string): any {
    return JSON.parse(localStorage.getItem(arg0));
  }

  getURLSearchParamsFromObject(data: any): FormData {
    const formData = new FormData();
    if (data != null && data != undefined) {
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
    }
    return formData;
  }

  getBranchFlow(
    elm: any,
    translateService: TranslateService,
    type = "html",
    seperator = ""
  ) {
    var addedPaths = []; //Restrict Duplicates
    var data = ``;
    if (elm)
      Object.keys(elm).forEach(function (key) {
        let flow = elm[key];
        if (key == "corporations") {
          flow.forEach(function (corporation) {
            if (!corporation.hasOwnProperty("branch_no")) {
              return;
            }
            var flowHtml = "";
            if (type == "html") {
              flowHtml = `<div>`;
              flowHtml += `<span>` + corporation.Const_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml += `<span>` + corporation.cons_circle_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml += `<span>` + corporation.section_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml +=
                `<span>` +
                translateService.instant("Ward") +
                " " +
                corporation.ward_no +
                `</span>`;
              flowHtml += `<span>/</span>`;
              if (corporation.branch_name) {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  corporation.branch_no +
                  ` (` +
                  corporation.branch_name +
                  `)</span>`;
              } else {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  corporation.branch_no +
                  `</span>`;
              }
              flowHtml += `</div>`;
            } else {
              flowHtml += corporation.Const_name;
              flowHtml += seperator;
              flowHtml += corporation.cons_circle_name;
              flowHtml += seperator;
              flowHtml += corporation.section_name;
              flowHtml += seperator;
              flowHtml +=
                translateService.instant("Ward") + " " + corporation.ward_no;

              flowHtml += seperator;
              if (corporation.branch_name) {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  corporation.branch_no +
                  ` (` +
                  corporation.branch_name +
                  `)`;
              } else {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  corporation.branch_no;
              }
            }

            if (!addedPaths.includes(flowHtml)) {
              data += flowHtml;
              addedPaths.push(flowHtml);
            }
          });
        } else if (key == "municipals") {
          flow.forEach(function (municipal) {
            if (!municipal.hasOwnProperty("branch_no")) {
              return;
            }
            var flowHtml = ``;
            if (type == "html") {
              flowHtml = `<div>`;
              flowHtml += `<span>` + municipal.Const_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml += `<span>` + municipal.cons_circle_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml += `<span>` + municipal.section_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml +=
                `<span>` +
                translateService.instant("Ward") +
                " " +
                municipal.ward_no +
                `</span>`;
              flowHtml += `<span>/</span>`;
              if (municipal.branch_name) {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  municipal.branch_no +
                  ` (` +
                  municipal.branch_name +
                  `)</span>`;
              } else {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  municipal.branch_no +
                  `</span>`;
              }
              flowHtml += `</div>`;
            } else {
              flowHtml += municipal.Const_name;
              flowHtml += seperator;
              flowHtml += municipal.cons_circle_name;
              flowHtml += seperator;
              flowHtml += municipal.section_name;
              flowHtml += seperator;
              flowHtml +=
                translateService.instant("Ward") + " " + municipal.ward_no;

              flowHtml += seperator;
              if (municipal.branch_name) {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  municipal.branch_no +
                  ` (` +
                  municipal.branch_name +
                  `)`;
              } else {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  municipal.branch_no;
              }
            }

            if (!addedPaths.includes(flowHtml)) {
              data += flowHtml;
              addedPaths.push(flowHtml);
            }
          });
        } else if (key == "town_panchayats") {
          flow.forEach(function (town_panchayat) {
            if (!town_panchayat.hasOwnProperty("branch_no")) {
              return;
            }
            var flowHtml = ``;
            if (type == "html") {
              flowHtml = `<div>`;
              flowHtml += `<span>` + town_panchayat.Const_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml +=
                `<span>` + town_panchayat.cons_circle_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml +=
                `<span>` +
                translateService.instant("Ward") +
                " " +
                town_panchayat.ward_no +
                `</span>`;
              flowHtml += `<span>/</span>`;
              if (town_panchayat.branch_name) {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  town_panchayat.branch_no +
                  ` (` +
                  town_panchayat.branch_name +
                  `)</span>`;
              } else {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  town_panchayat.branch_no +
                  `</span>`;
              }
              flowHtml += `</div>`;
            } else {
              flowHtml += town_panchayat.Const_name;
              flowHtml += seperator;
              flowHtml += town_panchayat.cons_circle_name;
              flowHtml += seperator;
              flowHtml +=
                translateService.instant("Ward") + " " + town_panchayat.ward_no;

              flowHtml += seperator;
              if (town_panchayat.branch_name) {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  town_panchayat.branch_no +
                  ` (` +
                  town_panchayat.branch_name +
                  `)`;
              } else {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  town_panchayat.branch_no;
              }
            }
            if (!addedPaths.includes(flowHtml)) {
              data += flowHtml;
              addedPaths.push(flowHtml);
            }
          });
        } else if (key == "unions") {
          flow.forEach(function (union) {
            if (!union.hasOwnProperty("branch_no")) {
              return;
            }
            var flowHtml = ``;
            if (type == "html") {
              flowHtml = `<div>`;
              flowHtml += `<span>` + union.Const_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml += `<span>` + union.cons_circle_name + `</span>`;
              flowHtml += `<span>/</span>`;
              flowHtml += `<span>` + union.panchayat_name + `</span>`;
              flowHtml += `<span>/</span>`;
              if (union.branch_name) {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  union.branch_no +
                  ` (` +
                  union.branch_name +
                  `)</span>`;
              } else {
                flowHtml +=
                  `<span>` +
                  translateService.instant("Branch") +
                  " " +
                  union.branch_no +
                  `</span>`;
              }
              flowHtml += `</div>`;
            } else {
              flowHtml += union.Const_name;
              flowHtml += seperator;
              flowHtml += union.cons_circle_name;
              flowHtml += seperator;
              flowHtml += union.panchayat_name;
              flowHtml += seperator;
              if (union.branch_name) {
                flowHtml +=
                  translateService.instant("Branch") +
                  " " +
                  union.branch_no +
                  ` (` +
                  union.branch_name +
                  `)`;
              } else {
                flowHtml +=
                  translateService.instant("Branch") + " " + union.branch_no;
              }
            }

            if (!addedPaths.includes(flowHtml)) {
              data += flowHtml;
              addedPaths.push(flowHtml);
            }
          });
        }
      });

    return data;
  }

  openWindowWithPost(url, data) {
    var form = document.createElement("form");
    form.target = "_blank";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";

    for (var key in data) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  getAppointmentStatus(
    appointment: any,
    userDataService: UserDataService
  ): number {
    let appointment_start = moment(
      appointment.date + " " + appointment.start_time
    );
    let appointment_end = moment(appointment.date + " " + appointment.end_time);

    if (appointment_start.diff(userDataService.serverTime) > 0) {
      //Still not started
      return Constants.APPOINTMENT_COMING_SOON;
    } else if (appointment_end.diff(userDataService.serverTime) > 0) {
      // in Progress
      return Constants.APPOINTMENT_IN_PROGRESS;
    } else {
      //Completed
      return Constants.APPOINTMENT_COMPLETED;
    }
  }

  mapObjectKeysForRequest(object) {
    var newObject = {};
    Object.keys(object).forEach((key) => {
      if (this.map.hasOwnProperty(key)) {
        newObject[this.map[key]] = object[key];
      } else {
        newObject[key] = object[key];
      }
    });

    return newObject;
  }

  mapRequestToObjectKeys(object) {
    var invertedMap = _.invert(this.map);
    var newObject = {};
    Object.keys(object).forEach((key) => {
      if (invertedMap.hasOwnProperty(key)) {
        newObject[invertedMap[key]] = object[key];
      } else {
        newObject[key] = object[key];
      }
    });

    return newObject;
  }

  getPlaceId(parameters: any) {
    switch (parameters.party_post_group_id) {
      case PUBLIC_POST_GROUP.COUNTRY:
        return parameters.country_id;
      case PUBLIC_POST_GROUP.DISTRICT:
        return parameters.district_id;
      case PUBLIC_POST_GROUP.ZONE:
        return parameters.zone_id;
      case PUBLIC_POST_GROUP.CONSTITUENCY:
        return parameters.const_id;
      case PUBLIC_POST_GROUP.UNION:
        return parameters.cons_circle_id;
      case PUBLIC_POST_GROUP.PANCHAYAT:
        return parameters.panchayat_id;
      case PUBLIC_POST_GROUP.CIRCLE:
        break;
      case PUBLIC_POST_GROUP.BRANCH:
        return parameters.branch_id;
      case PUBLIC_POST_GROUP.WARD:
        return parameters.ward_id;
      case PUBLIC_POST_GROUP.MUNICIPAL:
        return parameters.cons_circle_id;
      case PUBLIC_POST_GROUP.TOWN_PANCHAYAT:
        return parameters.cons_circle_id;
      case PUBLIC_POST_GROUP.CORPORATION:
        return parameters.cons_circle_id;
      case PUBLIC_POST_GROUP.BOOTH:
        return parameters.booth_id;
      case PUBLIC_POST_GROUP.MEMBER:
        break;
      case PUBLIC_POST_GROUP.SECTION:
        return parameters.section_id;
      case PUBLIC_POST_GROUP.LOKSABHA:
        return parameters.loksabha_id;
      case PUBLIC_POST_GROUP.WORLD:
        return parameters.country_id;
      case PUBLIC_POST_GROUP.TEAM:
        break;
    }
    return null;
  }

  generateBranchFlowPath(branch_flow: any) {
    var branch_path = "";
    if (branch_flow != null) {
      if (branch_flow.town_panchayats.length > 0) {
        if (branch_flow.town_panchayats[0].branch_name != null) {
          branch_path =
            branch_flow.town_panchayats[0].Const_name +
            "/" +
            branch_flow.town_panchayats[0].cons_circle_name +
            "/ சிறகம்(வார்டு)" +
            branch_flow.town_panchayats[0].ward_no +
            "/" +
            branch_flow.town_panchayats[0].branch_name;
        }
      } else if (branch_flow.unions.length > 0) {
        if (branch_flow.unions[0].branch_name != null) {
          branch_path =
            branch_flow.unions[0].Const_name +
            "/" +
            branch_flow.unions[0].cons_circle_name +
            "/ " +
            branch_flow.unions[0].panchayat_name +
            "/ கிளை " +
            branch_flow.unions[0].branch_no +
            " " +
            branch_flow.unions[0].branch_name;
        }
      } else if (branch_flow.municipals.length > 0) {
        if (branch_flow.municipals[0].branch_name != null) {
          branch_path =
            branch_flow.municipals[0].Const_name +
            "/" +
            branch_flow.municipals[0].cons_circle_name +
            "/ சிறகம்(வார்டு)" +
            branch_flow.municipals[0].ward_no +
            "/" +
            branch_flow.municipals[0].branch_name;
        }
      } else if (branch_flow.corporations.length > 0) {
        if (branch_flow.corporations[0].branch_name != null) {
          branch_path =
            branch_flow.corporations[0].Const_name +
            "/" +
            branch_flow.corporations[0].cons_circle_name +
            "/ சிறகம்(வார்டு)" +
            branch_flow.corporations[0].ward_no +
            "/" +
            branch_flow.corporations[0].branch_name;
        }
      }
    }
    return branch_path;
  }

  generateFlowPath(flow: any) {
    var branch_path = "";
    if (flow != null) {
      if (flow.town_panchayats?.length > 0) {
        let town_panchayat = flow.town_panchayats[0];
        if (town_panchayat.hasOwnProperty("Const_name")) {
          branch_path += town_panchayat.Const_name;
        }

        if (town_panchayat.hasOwnProperty("cons_circle_name")) {
          branch_path += "/" + town_panchayat?.cons_circle_name;
        }

        if (town_panchayat.hasOwnProperty("ward_no")) {
          branch_path += "/ சிறகம்(வார்டு)" + town_panchayat.ward_no;
        }

        if (town_panchayat.hasOwnProperty("branch_name")) {
          branch_path = "/" + town_panchayat.branch_name;
        }
      } else if (flow.unions?.length > 0) {
        let union = flow.unions[0];
        if (union.hasOwnProperty("Const_name")) {
          branch_path += union.Const_name;
        }

        if (union.hasOwnProperty("cons_circle_name")) {
          branch_path += "/" + union.cons_circle_name;
        }

        if (union.hasOwnProperty("panchayat_name")) {
          branch_path += "/" + union.panchayat_name;
        }
        if (union.hasOwnProperty("ward_no")) {
          branch_path += "/ சிறகம்(வார்டு)" + union.ward_no;
        }

        if (union.hasOwnProperty("branch_name")) {
          branch_path = "/" + union.branch_name;
        }
      } else if (flow.municipals?.length > 0) {
        let municipal = flow.municipals[0];
        if (municipal.hasOwnProperty("Const_name")) {
          branch_path = municipal.Const_name;
        }

        if (municipal.hasOwnProperty("cons_circle_name")) {
          branch_path += "/" + municipal.cons_circle_name;
        }

        if (municipal.hasOwnProperty("section_name")) {
          branch_path += "/" + municipal.section_name;
        }

        if (municipal.hasOwnProperty("ward_no")) {
          branch_path += "/ சிறகம்(வார்டு)" + municipal.ward_no;
        }
        if (municipal.hasOwnProperty("branch_name")) {
          branch_path += "/" + municipal.branch_name;
        }
      } else if (flow.corporations?.length > 0) {
        let corporation = flow.corporations[0];
        if (corporation.hasOwnProperty("Const_name")) {
          branch_path = corporation.Const_name;
        }

        if (corporation.hasOwnProperty("cons_circle_name")) {
          branch_path += "/" + corporation.cons_circle_name;
        } else if (corporation.hasOwnProperty("union_name")) {
          branch_path += "/" + corporation.union_name;
        }

        if (corporation.hasOwnProperty("section_name")) {
          branch_path += "/" + corporation.section_name;
        }

        if (corporation.hasOwnProperty("ward_no")) {
          branch_path += "/ சிறகம்(வார்டு)" + corporation.ward_no;
        }
        if (corporation.hasOwnProperty("branch_name")) {
          branch_path += "/" + corporation.branch_name;
        }
      }
    }
    return branch_path;
  }

  drawExpenseTable(json) {
    var html = ``;
    let event_groups = json.event_groups;
    let cons_circle_list = json.cons_circle_list;
    let events = json.result;

    html = `<center class="mt-2">`;
    html += `<h3>செலவுகள்</h3>`;
    html += `<table style="width:1000px !important;" class="pangalipu expense-summary-table table-with-border">`;
    html += `<thead>`;
    html += `<tr>`;
    html += `<th style="width:200px;">#</th>`;

    cons_circle_list.forEach(function (elm, index) {
      if (index == 0) {
        html +=
          `<th class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>` +
          elm.Const_name +
          `</span></th>`;
      }
      if (
        elm.union_type == Constants.MUNICIPAL ||
        elm.union_type == Constants.CORPORATION
      ) {
        let sections = JSON.parse(elm.sections);
        sections.forEach(function (section) {
          html +=
            `<th class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>` +
            section.section_name +
            `</span></th>`;
        });
      } else {
        html +=
          `<th class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>` +
          elm.union_name +
          `</span></th>`;
      }
    });

    html += `<th class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>மொத்தம்</span></th>`;

    html += `</tr>`;
    html += `</thead>`;
    html += `<tbody>`;

    var total_event_count = 0;
    var total_event_amount = 0;
    event_groups.forEach(function (elm) {
      html += `<tr>`;
      html +=
        `<td class="lhead accent-200" style="background: #d5dbd4 !important;">` +
        elm.group_name +
        `</td>`;
      var event_group_amount = 0;
      var event_group_count = 0;

      cons_circle_list.forEach(function (cons_circle, index) {
        var expense_amount = 0;
        var event_count = 0;
        //Constituency
        if (index == 0) {
          events.forEach(function (event) {
            var isConstituencyEevent = false;
            if (event.event_place) {
              let event_place = JSON.parse(event.event_place);
              if (event_place.length > 0) {
                isConstituencyEevent =
                  (event_place[0].const_id == cons_circle.Const_Id &&
                    event_place[0].cons_circle_id == null) ||
                  (cons_circle.Const_Id && event_place[0].cons_circle_id == -1);
              } else {
                isConstituencyEevent =
                  event.cons_circle_id == -1 || event.cons_circle_id == null;
              }
            }
            if (
              event.event_group_id == elm.event_group_id &&
              isConstituencyEevent
            ) {
              event_count += 1;
              let expenses = JSON.parse(event.expenses);
              expenses.forEach(function (expense) {
                expense_amount += expense.amount;
              });
            }
          });
          if (expense_amount == 0 && event_count == 0) {
            html += `<td><span></span><br><br><span class="text-danger"></span></td>`;
          } else {
            html +=
              `<td><span>` +
              event_count +
              `</span><br><br><span class="text-danger">₹` +
              expense_amount +
              `</span></td>`;
          }
        }

        event_group_amount += expense_amount;
        event_group_count += event_count;
        total_event_count += event_count;
        total_event_amount += expense_amount;

        expense_amount = 0;
        event_count = 0;

        if (
          cons_circle.union_type == Constants.MUNICIPAL ||
          cons_circle.union_type == Constants.CORPORATION
        ) {
          let sections = JSON.parse(cons_circle.sections);
          sections.forEach(function (section) {
            expense_amount = 0;
            event_count = 0;
            events.forEach(function (event) {
              var section_id = -1;
              if (
                event.event_place &&
                JSON.parse(event.event_place).length > 0
              ) {
                section_id = JSON.parse(event.event_place)[0].section_id;
              }
              if (
                event.event_group_id == elm.event_group_id &&
                event.cons_circle_id == cons_circle.cons_circle_id &&
                section_id == section.section_id
              ) {
                event_count += 1;
                let expenses = JSON.parse(event.expenses);
                expenses.forEach(function (expense) {
                  expense_amount += expense.amount;
                });
              }
            });

            if (expense_amount == 0 && event_count == 0) {
              html += `<td><span></span><br><br><span class="text-danger"></span></td>`;
            } else {
              html +=
                `<td><span>` +
                event_count +
                `</span><br><br><span class="text-danger">₹` +
                expense_amount +
                `</span></td>`;
            }

            event_group_amount += expense_amount;
            event_group_count += event_count;

            total_event_count += event_count;
            total_event_amount += expense_amount;
          });
        } else {
          events.forEach(function (event) {
            var isSameConsCircle = false;
            if (event.event_place) {
              let event_place = JSON.parse(event.event_place);
              if (event_place.length > 0) {
                isSameConsCircle =
                  event_place[0].cons_circle_id == cons_circle.cons_circle_id &&
                  (event_place[0].section_id == -1 ||
                    event_place[0].section_id == null);
              }
            }
            if (
              event.event_group_id == elm.event_group_id &&
              isSameConsCircle
            ) {
              event_count += 1;
              let expenses = JSON.parse(event.expenses);
              expenses.forEach(function (expense) {
                expense_amount += expense.amount;
              });
            }
          });
          if (expense_amount == 0 && event_count == 0) {
            html += `<td><span></span><br><br><span class="text-danger"></span></td>`;
          } else {
            html +=
              `<td><span>` +
              event_count +
              `</span><br><br><span class="text-danger">₹` +
              expense_amount +
              `</span></td>`;
          }

          event_group_amount += expense_amount;
          event_group_count += event_count;

          total_event_count += event_count;
          total_event_amount += expense_amount;
        }
      });

      if (event_group_count != 0) {
        html +=
          `<td><span>` +
          event_group_count +
          `</span><br><br><span class="text-danger">₹` +
          event_group_amount +
          `</span></td>`;
      } else {
        html += `<td><span></span><br><br><span class="text-danger"></span></td>`;
      }

      html += `</tr>`;
    });

    html += `<tr>`;
    html += `<td class="lhead accent-200" style="background: #d5dbd4 !important;">மொத்தம்</td>`;
    cons_circle_list.forEach(function (cons_circle, index) {
      var expense_amount = 0;
      var event_count = 0;

      if (index == 0) {
        events.forEach(function (event) {
          var isConstituencyEevent = false;
          if (event.event_place) {
            let event_place = JSON.parse(event.event_place);
            if (event_place.length > 0) {
              isConstituencyEevent =
                (event_place[0].const_id == cons_circle.Const_Id &&
                  event_place[0].cons_circle_id == null) ||
                (cons_circle.Const_Id && event_place[0].cons_circle_id == -1);
            } else if (
              event.cons_circle_id == -1 ||
              event.cons_circle_id == null
            ) {
              isConstituencyEevent = true;
            }
          }

          if (isConstituencyEevent) {
            event_count += 1;
            let expenses = JSON.parse(event.expenses);
            expenses.forEach(function (expense) {
              expense_amount += expense.amount;
            });
          }
        });

        html +=
          `<td><span>` +
          event_count +
          `</span><br><br><span class="text-danger">₹` +
          expense_amount +
          `</span></td>`;
      }

      expense_amount = 0;
      event_count = 0;

      if (
        cons_circle.union_type == Constants.MUNICIPAL ||
        cons_circle.union_type == Constants.CORPORATION
      ) {
        let sections = JSON.parse(cons_circle.sections);
        sections.forEach(function (section) {
          expense_amount = 0;
          event_count = 0;

          events.forEach(function (event) {
            var isSameSection = false;
            if (event.event_place) {
              let event_place = JSON.parse(event.event_place);
              if (event_place.length > 0) {
                isSameSection =
                  event_place[0].cons_circle_id == cons_circle.cons_circle_id &&
                  event_place[0].section_id == section.section_id;
              }
            }

            if (isSameSection) {
              event_count += 1;
              let expenses = JSON.parse(event.expenses);
              expenses.forEach(function (expense) {
                expense_amount += expense.amount;
              });
            }
          });

          html +=
            `<td><span>` +
            event_count +
            `</span><br><br><span class="text-danger">₹` +
            expense_amount +
            `</span></td>`;
        });
      } else {
        events.forEach(function (event) {
          var isSameConsCircle = false;
          if (event.event_place) {
            let event_place = JSON.parse(event.event_place);
            if (event_place.length > 0) {
              isSameConsCircle =
                event_place[0].cons_circle_id == cons_circle.cons_circle_id &&
                (event_place[0].section_id == -1 ||
                  event_place[0].section_id == null);
            }
          }
          if (isSameConsCircle) {
            event_count += 1;
            let expenses = JSON.parse(event.expenses);
            expenses.forEach(function (expense) {
              expense_amount += expense.amount;
            });
          }
        });

        html +=
          `<td><span>` +
          event_count +
          `</span><br><br><span class="text-danger">₹` +
          expense_amount +
          `</span></td>`;
      }
    });

    html +=
      `<td><span>` +
      total_event_count +
      `</span><br><br><span class="text-danger">₹` +
      total_event_amount +
      `</span></td>`;

    html += `</tr>`;

    html += `</tbody>`;
    html += `</table>`;
    html += `</center>`;

    html += `<script>
  var header_height = 0;

  $('.expense-summary-table thead th span').each(function() {
    if ($(this).outerWidth() > header_height)
      header_height = $(this).outerWidth();
  });

  $('.expense-summary-table thead th').height(header_height);
  </script>`;

    return html;
  }

  drawContributionTable(json) {
    var html = ``;
    let event_groups = json.event_groups;
    let cons_circle_list = json.cons_circle_list;
    let events = json.result;

    html = `<center class="mt-2">`;
    html += `<h3>பங்களிப்புகள்</h3>`;
    html += `<table style="width:1000px !important;" class="pangalipu contribution-summary-table table-with-border">`;
    html += `<thead>`;
    html += `<tr>`;
    html += `<th style="width:200px;">#</th>`;

    cons_circle_list.forEach(function (elm, index) {
      if (index == 0) {
        html +=
          `<th  class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>` +
          elm.Const_name +
          `</span></th>`;
      }
      if (
        elm.union_type == Constants.MUNICIPAL ||
        elm.union_type == Constants.CORPORATION
      ) {
        let sections = JSON.parse(elm.sections);
        sections.forEach(function (section) {
          html +=
            `<th  class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>` +
            section.section_name +
            `</span></th>`;
        });
      } else {
        html +=
          `<th  class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>` +
          elm.union_name +
          `</span></th>`;
      }
    });
    html += `<th  class="head accent-200 accent-200" style="background: #d5dbd4 !important;" scope="col"><span>மொத்தம்</span></th>`;
    html += `</tr>`;
    html += `</thead>`;
    html += `<tbody>`;

    event_groups = event_groups.filter(function (elm) {
      var have = false;
      events.forEach(function (event) {
        if (event.event_group_id == elm.event_group_id) {
          have = true;
        }
      });
      return have;
    });

    var total_event_count = 0;
    var total_event_amount = 0;
    event_groups.forEach(function (elm) {
      html += `<tr>`;
      html +=
        `<td  class="head accent-200 accent-200" style="background: #d5dbd4 !important;">` +
        elm.group_name +
        `</td>`;

      var event_group_amount = 0;
      var event_group_count = 0;
      cons_circle_list.forEach(function (cons_circle, index) {
        var contribution_amount = 0;
        var event_count = 0;
        //Constituency - START
        if (index == 0) {
          events.forEach(function (event) {
            if (event.total_contribution == 3300) {
            }
            var isConstituencyEevent = false;
            if (event.event_place) {
              let event_place = JSON.parse(event.event_place);
              if (event_place.length > 0) {
                isConstituencyEevent =
                  (event_place[0].const_id == cons_circle.Const_Id &&
                    event_place[0].cons_circle_id == null) ||
                  (cons_circle.Const_Id && event_place[0].cons_circle_id == -1);
              } else {
                isConstituencyEevent =
                  event.cons_circle_id == -1 || event.cons_circle_id == null;
              }
            }
            if (
              event.event_group_id == elm.event_group_id &&
              isConstituencyEevent
            ) {
              event_count += 1;
              let contributions = JSON.parse(event.contributions);
              contributions.forEach(function (contribution) {
                contribution_amount += contribution.amount;
              });
            }
          });
          if (contribution_amount == 0 && event_count == 0) {
            html += `<td><span></span><br><br><span class="text-success"></span></td>`;
          } else {
            html +=
              `<td><span>` +
              event_count +
              `</span><br><br><span class="text-success">₹` +
              contribution_amount +
              `</span></td>`;
          }
        }
        event_group_amount += contribution_amount;
        event_group_count += event_count;

        total_event_count += event_count;
        total_event_amount += contribution_amount;

        //Constituency - END

        contribution_amount = 0;
        event_count = 0;
        if (
          cons_circle.union_type == Constants.MUNICIPAL ||
          cons_circle.union_type == Constants.CORPORATION
        ) {
          let sections = JSON.parse(cons_circle.sections);
          sections.forEach(function (section) {
            contribution_amount = 0;
            event_count = 0;
            events.forEach(function (event) {
              var isSameSection = false;
              if (event.event_place) {
                let event_place = JSON.parse(event.event_place);

                if (event_place.length > 0) {
                  isSameSection =
                    event_place[0].cons_circle_id ==
                      cons_circle.cons_circle_id &&
                    event_place[0].section_id == section.section_id;
                }
              }

              if (event.event_group_id == elm.event_group_id && isSameSection) {
                event_count += 1;
                let contributions = JSON.parse(event.contributions);
                contributions.forEach(function (contribution) {
                  contribution_amount += contribution.amount;
                });
              }
            });

            if (contribution_amount == 0 && event_count == 0) {
              html += `<td><span></span><br><br><span class="text-success"></span></td>`;
            } else {
              html +=
                `<td><span>` +
                event_count +
                `</span><br><br><span class="text-success">₹` +
                contribution_amount +
                `</span></td>`;
            }

            event_group_amount += contribution_amount;
            event_group_count += event_count;

            total_event_count += event_count;
            total_event_amount += contribution_amount;
          });
        } else {
          events.forEach(function (event) {
            var isSameConsCircle = false;
            if (event.event_place) {
              let event_place = JSON.parse(event.event_place);
              if (event_place.length > 0) {
                isSameConsCircle =
                  event_place[0].cons_circle_id == cons_circle.cons_circle_id &&
                  (event_place[0].section_id == -1 ||
                    event_place[0].section_id == null);
              }
            }

            if (
              event.event_group_id == elm.event_group_id &&
              isSameConsCircle
            ) {
              event_count += 1;
              let contributions = JSON.parse(event.contributions);
              contributions.forEach(function (contribution) {
                contribution_amount += contribution.amount;
              });
            }
          });
          if (contribution_amount == 0 && event_count == 0) {
            html += `<td><span></span><br><br><span class="text-success"></span></td>`;
          } else {
            html +=
              `<td><span>` +
              event_count +
              `</span><br><br><span class="text-success">₹` +
              contribution_amount +
              `</span></td>`;
          }

          event_group_amount += contribution_amount;
          event_group_count += event_count;

          total_event_count += event_count;
          total_event_amount += contribution_amount;
        }
      });

      html +=
        `<td><span>` +
        event_group_count +
        `</span><br><br><span class="text-success">₹` +
        event_group_amount +
        `</span></td>`;

      html += `</tr>`;
    });

    html += `<tr>`;
    html += `<td  class="head accent-200 accent-200" style="background: #d5dbd4 !important;">மொத்தம்</td>`;
    cons_circle_list.forEach(function (cons_circle, index) {
      var contribution_amount = 0;
      var event_count = 0;

      if (index == 0) {
        events.forEach(function (event) {
          var isConstituencyEevent = false;
          if (event.event_place) {
            let event_place = JSON.parse(event.event_place);
            if (event_place.length > 0) {
              isConstituencyEevent =
                (event_place[0].const_id == cons_circle.Const_Id &&
                  event_place[0].cons_circle_id == null) ||
                (cons_circle.Const_Id && event_place[0].cons_circle_id == -1);
            } else if (
              event.cons_circle_id == -1 ||
              event.cons_circle_id == null
            ) {
              isConstituencyEevent = true;
            }
          }

          if (isConstituencyEevent) {
            event_count += 1;
            let contributions = JSON.parse(event.contributions);
            contributions.forEach(function (contribution) {
              contribution_amount += contribution.amount;
            });
          }
        });

        html +=
          `<td><span>` +
          event_count +
          `</span><br><br><span class="text-success">₹` +
          contribution_amount +
          `</span></td>`;
      }

      contribution_amount = 0;
      event_count = 0;

      if (
        cons_circle.union_type == Constants.MUNICIPAL ||
        cons_circle.union_type == Constants.CORPORATION
      ) {
        let sections = JSON.parse(cons_circle.sections);
        sections.forEach(function (section) {
          contribution_amount = 0;
          event_count = 0;
          events.forEach(function (event) {
            var isSameSection = false;
            if (event.event_place) {
              let event_place = JSON.parse(event.event_place);
              if (event_place.length > 0) {
                isSameSection =
                  event_place[0].const_id == cons_circle.Const_Id &&
                  event_place[0].cons_circle_id == cons_circle.cons_circle_id &&
                  event_place[0].section_id == section.section_id;
              }
            }

            if (isSameSection) {
              event_count += 1;
              let contributions = JSON.parse(event.contributions);
              contributions.forEach(function (contribution) {
                contribution_amount += contribution.amount;
              });
            }
          });

          html +=
            `<td><span>` +
            event_count +
            `</span><br><br><span class="text-success">₹` +
            contribution_amount +
            `</span></td>`;
        });
      } else {
        events.forEach(function (event) {
          var isSameConsCircle = false;
          if (event.event_place) {
            let event_place = JSON.parse(event.event_place);
            if (event_place.length > 0) {
              isSameConsCircle =
                event_place[0].const_id == cons_circle.Const_Id &&
                event_place[0].cons_circle_id == cons_circle.cons_circle_id &&
                (event_place[0].section_id == -1 ||
                  event_place[0].section_id == null);
            }
          }

          if (isSameConsCircle) {
            event_count += 1;
            let contributions = JSON.parse(event.contributions);
            contributions.forEach(function (contribution) {
              contribution_amount += contribution.amount;
            });
          }
        });

        html +=
          `<td><span>` +
          event_count +
          `</span><br><br><span class="text-success">₹` +
          contribution_amount +
          `</span></td>`;
      }
    });

    html +=
      `<td><span>` +
      total_event_count +
      `</span><br><br><span class="text-success">₹` +
      total_event_amount +
      `</span></td>`;

    html += `</tr>`;

    html += `</tbody>`;
    html += `</table>`;
    html += `</center>`;

    html += `<script>
  var header_height = 0;

  $('.contribution-summary-table thead th span').each(function() {
    if ($(this).outerWidth() > header_height)
      header_height = $(this).outerWidth();
  });
  $('.contribution-summary-table thead th').height(header_height);
  </script>`;
    return html;
  }

  public getPlacePath(
    place_details: any,
    options = { ignore: [], only_place: false }
  ) {
    if (!options.hasOwnProperty("ignore")) {
      options.ignore = [];
    }
    if (!options.hasOwnProperty("only_place")) {
      options.only_place = false;
    }
    var place = "";
    if (place_details && place_details.hasOwnProperty("type")) {
      switch (place_details.type) {
        case "country":
          if (options.only_place) {
            return place_details.country_name;
          }
          place += place_details.country_name;
          break;
        case "district":
          if (options.only_place) {
            return place_details.district_name;
          }
          place += place_details.country_name;
          place += " / ";
          place += place_details.district_name;
          break;
        case "zone":
          if (options.only_place) {
            return place_details.zone_name;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }

          place += place_details.district_name;
          place += " / ";
          place += place_details.zone_name;
          break;
        case "constituency":
          if (options.only_place) {
            return place_details.const_name;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          break;
        case "cons_circle":
          if (options.only_place) {
            return place_details.cons_circle_name;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          place += " / ";
          place += place_details.cons_circle_name;
          break;
        case "section":
          if (options.only_place) {
            return place_details.section_name;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          place += " / ";
          place += place_details.cons_circle_name;
          place += " / ";
          place += place_details.section_name;
          break;
        case "panchayat":
          if (options.only_place) {
            return place_details.panchayat_name;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          place += " / ";
          place += place_details.cons_circle_name;
          place += " / ";
          place += place_details.panchayat_name;
          break;
        case "panchayat_branch":
          if (options.only_place) {
            return "கிளை " + place_details.branch_no;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          place += " / ";
          place += place_details.cons_circle_name;
          place += " / ";
          place += place_details.panchayat_name;
          place += " / ";
          place += "கிளை " + place_details.branch_no;
          break;

        case "ward_branch":
          if (options.only_place) {
            return "கிளை " + place_details.branch_no;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          place += " / ";
          place += place_details.cons_circle_name;
          place += " / ";
          place += "சிறகம் " + place_details.ward_no;
          place += " / ";
          place += "கிளை " + place_details.branch_no;
          break;
        case "section_ward_branch":
          if (options.only_place) {
            return "கிளை " + place_details.branch_no;
          }
          if (!options.ignore.includes("country")) {
            place += place_details.country_name;
            place += " / ";
          }
          place += place_details.district_name;
          place += " / ";
          place += place_details.const_name;
          place += " / ";
          place += place_details.cons_circle_name;
          place += " / ";
          place += place_details.section_name;
          place += " / ";
          place += "சிறகம் " + place_details.ward_no;
          place += " / ";
          place += "கிளை " + place_details.branch_no;
          break;
      }
    }
    return place;
  }

  getPlaceIdAndGroupId(parameters: any) {
    if (parameters.hasOwnProperty("booth_id")) {
      return {
        place_id: parameters.booth_id,
        group_id: PUBLIC_POST_GROUP.BOOTH,
      };
    } else if (parameters.hasOwnProperty("branch_id")) {
      return {
        place_id: parameters.branch_id,
        group_id: PUBLIC_POST_GROUP.BRANCH,
      };
    } else if (parameters.hasOwnProperty("ward_id")) {
      return {
        place_id: parameters.ward_id,
        group_id: PUBLIC_POST_GROUP.WARD,
      };
    } else if (parameters.hasOwnProperty("panchayat_id")) {
      return {
        place_id: parameters.panchayat_id,
        group_id: PUBLIC_POST_GROUP.PANCHAYAT,
      };
    } else if (parameters.hasOwnProperty("section_id")) {
      return {
        place_id: parameters.section_id,
        group_id: PUBLIC_POST_GROUP.SECTION,
      };
    } else if (parameters.hasOwnProperty("cons_circle_id")) {
      return {
        place_id: parameters.cons_circle_id,
        group_id: PUBLIC_POST_GROUP.UNION,
      };
    } else if (parameters.hasOwnProperty("const_id")) {
      return {
        place_id: parameters.const_id,
        group_id: PUBLIC_POST_GROUP.CONSTITUENCY,
      };
    } else if (parameters.hasOwnProperty("zone_id")) {
      return {
        place_id: parameters.zone_id,
        group_id: PUBLIC_POST_GROUP.ZONE,
      };
    } else if (parameters.hasOwnProperty("district_id")) {
      return {
        place_id: parameters.district_id,
        group_id: PUBLIC_POST_GROUP.DISTRICT,
      };
    } else if (parameters.hasOwnProperty("loksabha_cons_id")) {
      return {
        place_id: parameters.loksabha_cons_id,
        group_id: PUBLIC_POST_GROUP.LOKSABHA,
      };
    } else if (parameters.hasOwnProperty("country_id")) {
      return {
        place_id: parameters.country_id,
        group_id: PUBLIC_POST_GROUP.COUNTRY,
      };
    }
  }
  groupByBarrack(data) {
    //   let x = [
    //     {id:"1",hobby:"videogames"},
    //     {id:"1",hobby:"chess"},
    //     {id:"2",hobby:"chess"},
    //     {id:"3",hobby:"carrom"},
    //     {id:"4",hobby:"videogames"},
    //     {id:"4",hobby:"carrom"}
    //  ];

    let grouped = data.reduce((acc, cur) => {
      let { barrack_name, ...rest } = cur;
      rest.barrack_name = barrack_name;
      if (!acc[barrack_name]) {
        acc[barrack_name] = [];
      }
      acc[barrack_name].push(rest);
      return acc;
    }, {});

    let result = Object.entries(grouped).map(([key, value]) => ({
      [key]: value,
    }));

    return result;
    //  console.log(result);
  }
}
